import Slider from "react-slick";
import ComboPackageItem from "./ComboPackageItem";
import "./ComboPackages.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ComboPackages = ({ comboPackagesData }) => {
  const {
    combo_icon,
    combo_subtitle,
    combo_title,
    combo_packages: data,
  } = comboPackagesData;
  const visibleSlides = Math.min(4, data.length); // show max 4, or less if less items

  const settings = {
    infinite: data.length > visibleSlides, // don't loop if not enough slides
    autoplay: data.length > visibleSlides,
    autoplaySpeed: 3000,
    arrows: true,
    slidesToShow: visibleSlides,
    slidesToScroll: visibleSlides,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(2, data.length),
          slidesToScroll: Math.min(2, data.length),
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="home-combopkg-wrapper">
      <div className="home-combopkg-header">
        <img src={combo_icon} alt="" />
        <div>
          <div className="home-combopkg-title">{combo_title}</div>
          <div className="home-combopkg-subtitle">{combo_subtitle}</div>
        </div>
      </div>

      <div className="slider-container">
        <Slider {...settings}>
          {data?.map((item) => (
            <div key={item.package_id} className="combo-slide">
              <ComboPackageItem item={item} />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ComboPackages;
